const $showMoreButtons = document.querySelectorAll('.p-single-product-variants-list-show-more');

$showMoreButtons.forEach($button => {
	const $hiddenWrapper = $button.closest('.p-single-product-variants').querySelector('.p-single-product-variants-hidden');
	const closeText = $button.getAttribute('data-close-text');

	$button.addEventListener('click', () => {
		const isExpanded = $button.getAttribute('aria-expanded') === 'true';

		if (isExpanded) {
			$hiddenWrapper.style.display = 'none';
			$button.textContent = '+' + $hiddenWrapper.querySelectorAll('.p-single-product-variants-list-item').length;
			$button.setAttribute('aria-expanded', 'false');
		} else {
			$hiddenWrapper.style.display = 'block';
			$button.textContent = closeText;
			$button.setAttribute('aria-expanded', 'true');
		}
	});
});
